import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useZone } from 'zens-store'
import { useTranslation } from 'react-i18next'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  zoneId: number
  title?: string
  breadcrumbItems?: BreadcrumbData[]
}

const ZoneHeader = (props: Props) => {
  const { companyId, zoneId, title, breadcrumbItems, style, ...otherProps } = props
  const { t } = useTranslation()
  const zone = useZone({ companyId, zoneId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Zones'),
      href: `/companies/${companyId}/workspaces/zones`,
    },
    {
      title: zone.data?.name || '',
      href: `/companies/${companyId}/workspaces/zones/${zoneId}`,
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={title || zone.data?.name || ' '}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default ZoneHeader
